module.exports = __webpack_public_path__ + "static/style-f0954b830260d8cd1cc65213fb23ae9a.png";